module.exports = __webpack_public_path__ + "img/i-hospital-7.48916dfb.png";